/**
 * 格式化金额
 * @param str
 * @param digit 保留几位
 * @returns {string}
 */
function formatMoneyFilter (str, digit) {
  let minus = ''
  digit = digit || 2
  if (str) {
    if (!/\d+(\.\d+)?/.test(str + '')) return str
    let num = parseFloat(str).toFixed(digit)
    let sNum = /^\d+/g.exec(Math.abs(num))[0], length = sNum.length, y = Math.floor(length / 3);
    sNum = sNum.split('').reverse()
    for (let i = 1; i <= y; i++) {
      if (i === y && length / 3 === y) break
      sNum.splice((3 * i + i - 1), 0, ',')
    }
    if (num < 0) minus = '-'
    return minus + sNum.reverse().join('') + /\.\d+$/.exec(num)[0]
  } else {
    str = 0
    return str.toFixed(digit)
  }
}
function dateFilter (num, spl) {
  if( typeof num !== 'number') return num
  let date = new Date(num)
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month < 10 ? '0'+month : month;
  let day = date.getDate();
  day = day < 10 ? '0'+day : day;
  if (spl){
    return year+spl+month+spl+day
  } else {
    return year+'/'+month+'/'+day
  }
}

const install = function (Vue) {
  Vue.filter('formatMoneyFilter', formatMoneyFilter),
  Vue.filter('dateFilter', dateFilter)
}

export default install



// WEBPACK FOOTER //
// ./src/common/filter.js